import { useState } from 'react';
import { usersService } from '../services/users';
import { useFetch } from '../hooks/useFetch';
import DataTable from '../components/DataTable';
import Spinner from '../components/Spinner';
import StatusMessage from '../components/StatusMessage';
import Modal from '../components/Modal';
import type { AdminUser } from '../types';

const Users = () => {
  const [search, setSearch] = useState('');
  const [active, setActive] = useState('');
  const { data, loading, error, reload } = useFetch(() => usersService.list({ search, is_active: active || undefined }), [search, active]);
  const [resetUrl, setResetUrl] = useState<string | null>(null);
  const [msg, setMsg] = useState<string | null>(null);

  const toggle = async (u: AdminUser) => { setMsg(null); try { u.is_active ? await usersService.deactivate(u.id) : await usersService.activate(u.id); reload(); } catch (e) { setMsg((e as Error).message); } };
  const reset = async (u: AdminUser) => { setMsg(null); try { setResetUrl((await usersService.resetLink(u.id)).reset_link); } catch (e) { setMsg((e as Error).message); } };

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold">Users</h1>
      <div className="flex gap-2">
        <input className="border rounded px-3 py-2 text-sm" placeholder="Search name/email…" value={search} onChange={(e) => setSearch(e.target.value)} />
        <select className="border rounded px-3 py-2 text-sm" value={active} onChange={(e) => setActive(e.target.value)}>
          <option value="">All</option><option value="true">Active</option><option value="false">Inactive</option>
        </select>
      </div>
      {msg && <StatusMessage error={msg} />}
      <StatusMessage error={error} />
      {loading ? <Spinner /> : <DataTable<AdminUser>
        columns={[
          { key: 'full_name', header: 'Name' },
          { key: 'email', header: 'Email' },
          { key: 'company_name', header: 'Company', render: (r) => r.company_name ?? '—' },
          { key: 'user_role', header: 'Role' },
          { key: 'is_active', header: 'Active', render: (r) => r.is_active ? 'Yes' : 'No' },
          { key: 'actions', header: '', render: (r) => (
            <div className="flex gap-2">
              <button className="text-primary-600 text-sm" onClick={() => toggle(r)}>{r.is_active ? 'Deactivate' : 'Activate'}</button>
              <button className="text-gray-600 text-sm" onClick={() => reset(r)}>Reset link</button>
            </div>
          ) },
        ]}
        rows={data ?? []} />}
      <Modal open={!!resetUrl} title="Password reset link" onClose={() => setResetUrl(null)}>
        <div className="space-y-3 text-sm">
          <input readOnly className="w-full border rounded px-3 py-2" value={resetUrl ?? ''} onFocus={(e) => e.currentTarget.select()} />
          <button className="bg-primary-600 text-white rounded px-4 py-2 w-full" onClick={() => { if (resetUrl) navigator.clipboard.writeText(resetUrl); }}>Copy</button>
        </div>
      </Modal>
    </div>
  );
};
export default Users;
